import ChevronLeft from '@modules/common/icons/chevron-left';

type NavButtonsProps = {
  count: number;
  currentIndex: number;
  onPrev: () => void;
  onNext: () => void;
};

export const NavButtons = ({
  count,
  currentIndex,
  onPrev,
  onNext,
}: NavButtonsProps) => {
  if (count <= 1) {
    return null;
  }
  return (
    <>
      <button
        aria-label="Previous photo"
        className="absolute cursor-pointer left-4 top-1/2 z-10 flex size-8 -translate-y-1/2 items-center justify-center rounded-full border border-brand-primary-100 bg-white p-1 disabled:cursor-not-allowed disabled:opacity-50"
        disabled={currentIndex === 0}
        onClick={onPrev}
        type="button"
      >
        <ChevronLeft size="24" className="mr-[2px]" />
      </button>
      <button
        aria-label="Next photo"
        className="absolute cursor-pointer right-4 top-1/2 z-10 flex size-8 -translate-y-1/2 items-center justify-center rounded-full border border-brand-primary-100 bg-white p-1 disabled:cursor-not-allowed disabled:opacity-50"
        disabled={currentIndex === count - 1}
        onClick={onNext}
        type="button"
      >
        <ChevronLeft size="24" className="rotate-180 ml-[2px]" />
      </button>
    </>
  );
};
